import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../features/auth/auth.service';

/**
 * Customer role guard that checks if user is authenticated and has customer role
 * Redirects to appropriate route based on user role or to sign-in if not authenticated
 */
export const customerGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Check if user is authenticated
  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/auth/sign-in']);
  }

  // Check user role
  const userRole = authService.getUserRole();
  
  if (userRole === 'customer') {
    return true;
  }

  // If admin, redirect to admin dashboard
  if (userRole === 'admin') {
    return router.createUrlTree(['/admin/customers']);
  }

  // Fallback: redirect to sign-in
  return router.createUrlTree(['/auth/sign-in']);
};